export const alloysIntegrationsIntegrationIdBridge = "/alloys/integrations/:integration_id/bridge";
